<template>
  <div class="box-bd clearfix">
    <ul class="video-list clearfix">
      <li class="video-item " v-for="i in 4" :key="i">
        <a href="">
          <div class="figure figure-img">
            <img src="../../../assets/imgs/shiping_thumb.jpg" alt="" width="296" height="180">
            <span class="play">
              <i class="iconfont"></i>
            </span>
          </div>
          <h3 class="title">Redmi 10X系列发布会</h3>
          <p class="desc">Redmi 10X系列发布会</p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.home-video-box .video-list {
  width: 1240px;
  height: 285px;
  margin: 0;
  padding: 0;
  list-style-type: none;
  .video-item{ 
    position: relative;
    float: left;
    width: 296px;
    height: 285px;
    margin-left: 14px;
    margin-bottom: 14px;
    text-align: center;
    background: #fff;
    -webkit-transition: all .2s linear;
    transition: all .2s linear;
    a{
      background-color: rgba(0,0,0,0);
      .figure-img {
        position: relative;
        width: 296px;
        height: 180px;
        margin: 0 0 28px;
      }
      .play {
        position: absolute;
        left: 20px;
        bottom: 10px;
        width: 32px;
        height: 20px;
        border: 2px solid #fff;
        border-radius: 12px;
        background-color: #424242;
        background-color: rgba(0,0,0,.6);
        color: #fff;
        -webkit-transition: all .2s;
        transition: all .2s;
        overflow: hidden;
        i {
          font-size: 30px;
          line-height: 20px;
        }
      }
      .title {
        margin: 0 14px 6px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #333;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .desc{
        height: 18px;
        margin: 0 14px;
        font-size: 12px;
        color: #b0b0b0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .video-item:hover{
    z-index: 2;
    -webkit-box-shadow: 0 15px 30px rgba(0,0,0,.1);
    box-shadow: 0 15px 30px rgba(0,0,0,.1);
    -webkit-transform: translate3d(0,-2px,0);
    transform: translate3d(0,-2px,0);
    .play:hover{
      background-color: #f67900;
    }
  }
}
.home-video-box .video-item:first-child {
  margin-left: 0;
}
</style>